package com.eladfinish.bible.contest.screens.chapterComplete.model

import androidx.compose.runtime.Immutable
import kotlinx.collections.immutable.ImmutableList

@Immutable
data class UserCompletionsModel(
    val tokens: ImmutableList<Token>,
    val visibility: ImmutableList<Boolean>,
) {
    @Immutable
    data class Token(
        val raw: String,          // the original token text (word / makaf / colonSplitter etc.)
//        val kind: Kind,
        val isToggleable: Boolean,
    ) {
        enum class Kind {
            Word,
            ColonSplitter,
            Makaf,
            Paseq,
            OtPasuk,        // if you treat it as a token
            Other,
        }
    }
}
